// Configuración centralizada de equipos por defecto para toda la aplicación
export interface DefaultTeam {
  name: string;
  color: string;
  phases?: { [key: string]: number };
  total?: number;
}

// Definición de plantillas de equipos
export interface TeamTemplate {
  id: string;
  name: string;
  description: string;
  teams: DefaultTeam[];
}

// Plantilla de Tenerife Norte
const tenerifeNorteTeams: DefaultTeam[] = [
  // Naranja
  { name: "Chinguaro", color: "#f29d57" },
  { name: "Acaymo", color: "#f29d57" },
  { name: "Arena", color: "#f29d57" },
  { name: "Costeras", color: "#f29d57" },
  
  // Verde
  { name: "Las Guays", color: "#86b050" },
  { name: "Reinas valientes", color: "#86b050" },
  { name: "Arroyadoras", color: "#86b050" },
  { name: "Tagoro", color: "#86b050" },
  
  // Rojo
  { name: "Piña", color: "#bf3131" },
  { name: "Corujera", color: "#bf3131" },
  { name: "Guayota", color: "#bf3131" },
  { name: "Yeyes", color: "#bf3131" },
  { name: "Los Cipreses", color: "#bf3131" },
  
  // Amarillo
  { name: "Lomo Pelado", color: "#e6ba38" },
  { name: "Noveleras", color: "#e6ba38" },
  { name: "Poderosas", color: "#e6ba38" },
  { name: "Perlas", color: "#e6ba38" },
  { name: "Las Élites", color: "#e6ba38" },
  { name: "Madroño", color: "#e6ba38" }
];

// Plantilla de Tenerife Sur
const tenerifeSurTeams: DefaultTeam[] = [
  // SANTIAGO DEL TEIDE (Azul petróleo #4672b5)
  { name: "Arguayo 1", color: "#4672b5" },
  { name: "Las Viudas 1", color: "#4672b5" },
  { name: "Estrella", color: "#4672b5" },
  { name: "Coral", color: "#4672b5" },
  
  // ARAFO (Rosetón #d55ea7)
  { name: "Vengadoras", color: "#d55ea7" },
  { name: "Guerreras", color: "#d55ea7" },
  { name: "Indecisas", color: "#d55ea7" },
  { name: "Chachis", color: "#d55ea7" },
  { name: "Marejada Añavingo", color: "#d55ea7" },
  { name: "Risco Azul", color: "#d55ea7" },
  
  // GRANADILLA (Morado #5f73fb)
  { name: "Charco El Pino", color: "#5f73fb" },
  { name: "Hinojeros", color: "#5f73fb" },
  { name: "El Médano", color: "#5f73fb" },
  { name: "El Salto", color: "#5f73fb" },
  { name: "El Desierto", color: "#5f73fb" },
  { name: "Internacionales", color: "#5f73fb" },
  { name: "Chimiche", color: "#5f73fb" },
  
  // GUÍA DE ISORA (Azul flojo #c3dfe2)
  { name: "Monteji", color: "#c3dfe2" },
  { name: "Las Chicas de Tingara", color: "#c3dfe2" },
  { name: "Las Salinas", color: "#c3dfe2" },
  { name: "Tagara", color: "#c3dfe2" },
  { name: "Intocables", color: "#c3dfe2" },
  { name: "Las chicas de Guia", color: "#c3dfe2" },
  { name: "Ali Babá", color: "#c3dfe2" }
];

// Plantilla de Fuerteventura
const fuerteventuraTeams: DefaultTeam[] = [
  // Amarillo
  { name: "A POR TODAS", color: "#e6ba38" },
  { name: "EL OLIVERO", color: "#e6ba38" },
  { name: "LA MOLINA", color: "#e6ba38" },
  { name: "LA TAHONA", color: "#e6ba38" },
  { name: "LOS ALISIOS", color: "#e6ba38" },
  { name: "LAS GUIRRES", color: "#e6ba38" },
  
  // Azul claro
  { name: "EL FARO", color: "#c3dfe2" },
  { name: "AMIGOS DE PÁJARA", color: "#c3dfe2" },
  { name: "L@S ATREVID@S", color: "#c3dfe2" },
  { name: "PLAYAS DE PÁJARA", color: "#c3dfe2" },
  { name: "COFETE", color: "#c3dfe2" },
  { name: "PÁJARA SE MUEVE", color: "#c3dfe2" },
  { name: "LAS BELETÉN", color: "#bf3131" },
  { name: "MAXOPUERTO", color: "#bf3131" },
  { name: "LAS BAIFAS", color: "#bf3131" },
  { name: "LAS APAÑÁS", color: "#bf3131" },
  { name: "LOS PICARONES", color: "#bf3131" },
  
  // Azul
  { name: "L@S CANGREJ@S", color: "#4672b5" },
  { name: "CAMELLITO", color: "#4672b5" },
  { name: "LAS MORISCAS", color: "#4672b5" },
  
  // Rosa
  { name: "VIRGEN DE LA PEÑA", color: "#d55ea7" },
  
  // Verde
  { name: "LAS ELEGIDAS", color: "#86b050" },
  { name: "IMPARABLES", color: "#86b050" }
];

// Plantilla de La Palma
const lasPalmasTeams: DefaultTeam[] = [
  { name: "Decididas", color: "#c3dfe2" },
  { name: "Ciclón", color: "#ffffff" },
  { name: "Atrevidas", color: "#d55ea7" },
  { name: "Taburiente", color: "#86b050" },
  { name: "El Roque", color: "#4672b5" },
  { name: "Baltalímpicas", color: "#d55ea7" },
  { name: "Estrellas", color: "#c3dfe2" },
  { name: "La Graja", color: "#86b050" },
  { name: "Todoque", color: "#4672b5" },
  { name: "Norteñas", color: "#f29d57" },
  { name: "Los de Siempre", color: "#ffffff" },
  { name: "Ilusión", color: "#c3dfe2" },
  { name: "Eléctric@s", color: "#75addb" },
  { name: "Zamora", color: "#bf3131" },
  { name: "Bagañetas", color: "#e6ba38" },
  { name: "Aridane", color: "#4672b5" },
  { name: "Celtas Cortos", color: "#ffffff" },
  { name: "Echentive", color: "#bf3131" },
  { name: "Enchufadas", color: "#75addb" },
  { name: "Tazacorte", color: "#e6ba38" },
  { name: "Unidas", color: "#c3dfe2" },
];

// Definición de todas las plantillas disponibles
export const teamTemplates: TeamTemplate[] = [
  {
    id: 'tenerife-norte',
    name: 'Tenerife Norte',
    description: 'Equipos participantes de la zona norte de Tenerife',
    teams: tenerifeNorteTeams
  },
  {
    id: 'tenerife-sur',
    name: 'Tenerife Sur',
    description: 'Equipos participantes de la zona sur de Tenerife',
    teams: tenerifeSurTeams
  },
  {
    id: 'fuerteventura',
    name: 'Fuerteventura',
    description: 'Equipos participantes de Fuerteventura',
    teams: fuerteventuraTeams
  },
  {
    id: 'la-palma',
    name: 'La Palma',
    description: 'Equipos participantes de La Palma',
    teams: lasPalmasTeams
  }
];

// Mantener compatibilidad hacia atrás
export const defaultTeams: DefaultTeam[] = tenerifeNorteTeams;

// Función para obtener una plantilla por ID
export const getTeamTemplate = (templateId: string): TeamTemplate | null => {
  return teamTemplates.find(template => template.id === templateId) || null;
};

// Función para obtener equipos de una plantilla específica
export const getTeamsFromTemplate = (templateId: string): DefaultTeam[] => {
  const template = getTeamTemplate(templateId);
  return template ? template.teams : defaultTeams;
};

// Función para obtener equipos con estructura de fases para leaderboard
export const getDefaultTeamsForLeaderboard = (
  phaseNames: { [key: string]: string }, 
  templateId?: string
): Array<{
  name: string;
  color: string;
  phases: { [key: string]: number };
  total: number;
}> => {
  const teams = templateId ? getTeamsFromTemplate(templateId) : defaultTeams;
  return teams.map(team => ({
    name: team.name,
    color: team.color,
    phases: Object.keys(phaseNames).reduce((acc, phaseKey) => {
      acc[phaseKey] = 0;
      return acc;
    }, {} as { [key: string]: number }),
    total: 0
  }));
};

// Función para obtener equipos simples para bracket
export const getDefaultTeamsForBracket = (templateId?: string): Array<{ name: string; color: string }> => {
  const teams = templateId ? getTeamsFromTemplate(templateId) : defaultTeams;
  return teams.map(team => ({
    name: team.name,
    color: team.color
  }));
};

// Equipos adicionales de Tenerife para casos específicos
export const tenerifeFallbackTeams: DefaultTeam[] = [
  // Naranja
  { name: "Chinguaro", color: "#f29d57" },
  { name: "Acaymo", color: "#f29d57" },
  { name: "Arena", color: "#f29d57" },
  { name: "Costeras", color: "#f29d57" },
  
  // Verde
  { name: "Las Guays", color: "#86b050" },
  { name: "San Juan: Reinas valientes", color: "#86b050" },
  { name: "Arroyadoras", color: "#86b050" },
  { name: "Tagoro", color: "#86b050" },
  
  // Rojo
  { name: "La Tosca: Piña", color: "#bf3131" },
  { name: "Corujera", color: "#bf3131" },
  { name: "Guayota", color: "#bf3131" },
  { name: "L@s Yeyes", color: "#bf3131" },
  { name: "Los Cipreses", color: "#bf3131" },
  
  // Amarillo
  { name: "Lomo Pelado", color: "#e6ba38" },
  { name: "Noveleras", color: "#e6ba38" },
  { name: "Poderosas", color: "#e6ba38" },
  { name: "Neuronas", color: "#e6ba38" },
  { name: "Las Élites", color: "#e6ba38" },
  { name: "Madroño", color: "#e6ba38" }
];

export const getTenerifeFallbackTeamsForLeaderboard = (phaseNames: { [key: string]: string }): Array<{
  name: string;
  color: string;
  phases: { [key: string]: number };
  total: number;
}> => {
  return tenerifeFallbackTeams.map(team => ({
    name: team.name,
    color: team.color,
    phases: Object.keys(phaseNames).reduce((acc, phaseKey) => {
      acc[phaseKey] = 0;
      return acc;
    }, {} as { [key: string]: number }),
    total: 0
  }));
};
